import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import TextTransition, { presets } from 'react-text-transition';

const HEADLINES = [
  'Hallo_smava',
  'Hello_smava',
  'Merhaba_smava',
  'Hola_smava',
  'Ciao_smava',
  'Ni hao_smava',
  'Namaste_smava',
];
const TIME_INTERVAL = 3 * 1000;

const AnimationContainer = styled('div')`
  margin: 0;
`;

// uses https://www.npmjs.com/package/react-text-transition
export const JobsAnimation = () => {
  const [index, setIndex] = useState(0);

  React.useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      TIME_INTERVAL,
    );
    return () => clearTimeout(intervalId);
  }, []);

  return (
    <AnimationContainer>
      <Typography variant="h1" style={{ color: '#ffffff', fontSize: '3.5rem' }}>
        <TextTransition springConfig={presets.wobbly}>
          {HEADLINES[index % HEADLINES.length]}
        </TextTransition>
      </Typography>
      <Typography variant="h3" component="h2" style={{ color: '#c8c8c8' }}>
        Schön, dich kennenzulernen
      </Typography>
    </AnimationContainer>
  );
};
